/*
 * Automatically generated by SVGR from assets/icons/*.svg.
 * Do not edit this file or add other components to this directory.
 */
import type { SVGProps } from 'react'
export function ThermostatCoolIcon(
  props: SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <path
        fill='#6B95FF'
        d='M7.25 15.5v-3.113l-2.437 2.4-1.05-1.05L7.25 10.25v-1.5h-1.5l-3.487 3.488-1.05-1.05 2.4-2.438H.5v-1.5h3.113l-2.4-2.437 1.05-1.05L5.75 7.25h1.5v-1.5L3.763 2.263l1.05-1.05 2.437 2.4V.5h1.5v3.113l2.438-2.4 1.05 1.05L8.75 5.75v1.5h1.5l3.488-3.487 1.05 1.05-2.4 2.437H15.5v1.5h-3.113l2.4 2.438-1.05 1.05L10.25 8.75h-1.5v1.5l3.488 3.488-1.05 1.05-2.438-2.4V15.5z'
      />
    </svg>
  )
}
